import { render, staticRenderFns } from "./ErrorAPICode.vue?vue&type=template&id=9972cf8a&"
import script from "./ErrorAPICode.vue?vue&type=script&lang=js&"
export * from "./ErrorAPICode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports